import baseAssetsModule from '../baseAssets/module';
import { HomepageSegmentLazyLoader } from "@/homepageSegmentLazyLoader";

export const cookieService = {
    setCookieValue: (value) => {
        baseAssetsModule.setCookie('__Host-gdprCookie', value, 365);

        $('.js_cookie-bar').addClass('hidden');
        $('body').removeClass('showCookieBar');
    },
    cookieBarInit: () => {
        const $body = $('.js_body');
        const $cookieBar = $('.js_cookie-bar');
        const oldGdprCookie = baseAssetsModule.getCookie('gdprCookie');
        const gdprCookieExists = oldGdprCookie || baseAssetsModule.getCookie('__Host-gdprCookie');

        if (oldGdprCookie !== '') {
            baseAssetsModule.setCookie('gdprCookie', '', -1);
            const oldGdprCookieValue = oldGdprCookie === 'true';
            baseAssetsModule.setCookie('__Host-gdprCookie', oldGdprCookieValue, 365);
        }

        $('.js_cookie-bar__accept').click(() => {
            cookieService.setCookieValue(true);
            $body.removeClass('body-scroll');
            $cookieBar.removeClass('body-scroll');

            const userData = window.customer;

            if (userData) {
                baseAssetsModule.setCookie('__Host-cartLineCount', userData.cartLineCount, 365);
            }

            HomepageSegmentLazyLoader();
        });

        $('.js_cookie-bar__decline').click(() => {
            cookieService.setCookieValue(false);
            $body.removeClass('body-scroll');
            $cookieBar.removeClass('body-scroll');
            HomepageSegmentLazyLoader();
        });

        if (window.location.href.includes('veiligheid-en-privacy') && (!gdprCookieExists || gdprCookieExists === 'false')) {
            return;
        }

        if (!gdprCookieExists) {
            $('body').addClass('showCookieBar');
            $cookieBar.removeClass('hidden');
            $body.addClass('body-scroll');

            return;
        } else {
            $('body').removeClass('showCookieBar');
            $cookieBar.addClass('hidden');
            $body.removeClass('body-scroll');

            return;
        }

        if (!window.env.isGaEnabled) {
            return;
        }

    },
}
